import { cloneObject } from '../../../../utils';
import { getFields } from '../../../../utils/defaultFields';

const fields = [
    'cep',
    'address',
    'addressNumber',
    'complement',
    'hood',
    'uf',
    'city',
    'cellphone',
    'phone',
    'ramal',
    'email',
];

const schema = cloneObject(getFields(fields));

schema.email.required = false;

schema.email2 = {
    ...schema.email,
    label: 'E-mail 2',
    id: 'email2',
};

schema.phone2 = {
    ...schema.phone,
    label: 'Telefone 2',
    id: 'phone2',
    required: false,
};

export default schema;
